var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetadata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m57 8h-50c-2.8 0-5 2.3-5 5v38c0 2.8 2.3 5 5 5h50c2.8 0 5-2.3 5-5v-38c0-2.7-2.3-5-5-5zm1 43c0 .6-.5 1-1 1h-50c-.6 0-1-.5-1-1v-38c0-.6.5-1 1-1h50c.6 0 1 .5 1 1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.4 24.6c-.8-.8-2-.8-2.8 0l-8 8c-.8.8-.8 2 0 2.8l8 8c.4.4.9.6 1.4.6s1-.2 1.4-.6c.8-.8.8-2 0-2.8l-6.6-6.6 6.6-6.6c.8-.8.8-2 0-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.4 24.6c-.8-.8-2-.8-2.8 0s-.8 2 0 2.8l6.6 6.6-6.6 6.6c-.8.8-.8 2 0 2.8.4.4.9.6 1.4.6s1-.2 1.4-.6l8-8c.8-.8.8-2 0-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.7 21.1c-1-.4-2.2.2-2.5 1.2l-8 23c-.4 1 .2 2.2 1.2 2.5.2.2.4.2.6.2.8 0 1.6-.5 1.9-1.3l8-23c.4-1.1-.2-2.2-1.2-2.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetadata);
export default __webpack_public_path__ + "static/media/metadata.31b783eaebbe103492c5d055a4af58ec.svg";
export { ForwardRef as ReactComponent };